import React from "react";
import { TextField } from "@material-ui/core";

export default function TextFieldUF(props) {
  const handleKeyDown = (event) => {
    // Permitir teclas como Backspace, Delete, Setas, Tab
    if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(event.key)) {
      return;
    }

    // Bloquear se não for uma letra e limitar a 2 caracteres
    if (!/^[a-zA-Z]$/.test(event.key) || event.target.value.length >= 2) {
      event.preventDefault();
    }
  };

  const handleChange = (event) => {
    // Garantir que apenas letras sejam mantidas e limitar a 2 caracteres
    const newValue = event.target.value.replace(/[^a-zA-Z]/g, "").toUpperCase().slice(0, 2);
    if (props.onChange) {
      props.onChange({
        ...event,
        target: { ...event.target, value: newValue },
      });
    }
  };

  return (
    <TextField
      {...props}
      inputProps={{ maxLength: 2 }}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
    />
  );
}
